export enum CollectionActions {
  CREATE_REQUEST = '[CollectionActions] CREATE',
  CREATE_SUCCESS = '[CollectionActions] CREATE_SUCCESS',
  CREATE_ERROR = '[CollectionActions] CREATE_ERROR',
  UPDATE_REQUEST = '[CollectionActions] UPDATE_REQUEST',
  UPDATE_SUCCESS = '[CollectionActions] UPDATE_SUCCESS',
  UPDATE_ERROR = '[CollectionActions] UPDATE_ERROR',
  UPDATE_LIST_REQUEST = '[CollectionActions] UPDATE_LIST_REQUEST',
  UPDATE_LIST_SUCCESS = '[CollectionActions] UPDATE_LIST_SUCCESS',
  UPDATE_LIST_ERROR = '[CollectionActions] UPDATE_LIST_ERROR',
  DELETE_REQUEST = '[CollectionActions] DELETE_REQUEST',
  DELETE_SUCCESS = '[CollectionActions] DELETE_SUCCESS',
  DELETE_ERROR = '[CollectionActions] DELETE_ERROR',
  ADD_ASSETS_REQUEST = '[CollectionActions] ADD_ASSETS_REQUEST',
  ADD_ASSETS_SUCCESS = '[CollectionActions] ADD_ASSETS_SUCCESS',
  ADD_ASSETS_ERROR = '[CollectionActions] ADD_ASSETS_ERROR',
  REMOVE_ASSETS_REQUEST = '[CollectionActions] REMOVE_ASSETS_REQUEST',
  REMOVE_ASSETS_SUCCESS = '[CollectionActions] REMOVE_ASSETS_SUCCESS',
  REMOVE_ASSETS_ERROR = '[CollectionActions] REMOVE_ASSETS_ERROR',
  CHANGE_NAME_REQUEST = '[CollectionActions] CHANGE_NAME_REQUEST',
  CHANGE_NAME_SUCCESS = '[CollectionActions] CHANGE_NAME_SUCCESS',
  CHANGE_NAME_ERROR = '[CollectionActions] CHANGE_NAME_ERROR',
  SET_AS_DEFAULT = '[CollectionActions] SET_AS_DEFAULT',
}
